import apiEndpoints from "@/util/apiEndpoints";
import API from "@/shared/API";

export const getStudies = (querySrring) => {
  return API.get(`${apiEndpoints.getRadStudies}${querySrring}`);
};
